import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";
import { getFeatureDetails } from "../../../../redux/actions/campaignActions";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import { token } from "../../../../components/constant/constant";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";

const Editteam = () => {
  const [file, setFile] = useState({
    files: "",
    preview:
      "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
  });
  const [isFile, setIsFile] = useState(false);
  const [profile_pic_name, setProfile_pic_name] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const id = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const featureView = useSelector((state) => state.featureView);
  const { feature } = featureView;

  let token = localStorage.getItem("accessToken");

  useEffect(() => {
    dispatch(getFeatureDetails(token, id, navigate));
  }, [dispatch]);

  useEffect(() => {
    if (feature?.data?.feature_image !== null) {
      setFile({
        files: feature?.data?.feature_image,
        preview: feature?.data?.feature_image,
      });
    } else {
      setFile({
        files: "",
        preview:
          "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
      });
    }
  }, [feature]);

  useEffect(() => {
    if (featureView) {
      if (featureView?.loading !== undefined) {
        setLoading(featureView?.loading);
      }
    }
  }, [featureView]);

  useEffect(() => {}, [file]);

  useEffect(() => {
    if (feature) {
      setValue("feature_name", feature?.data?.feature_name);
      setValue("feature_title", feature?.data?.feature_title);
      setValue("feature_description", feature?.data?.feature_description);
      setProfile_pic_name(feature?.data?.feature_image);
    }
  }, [feature]);

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const profileImage = (e) => {
    const selected = e.target.files[0];
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      setError(false);
      setFile({
        files: e.target.files[0],
        preview: URL.createObjectURL(e.target.files[0]),
      });
      setIsFile(true);
    } else {
      setError(true);
    }
  };

  // const profileImage = async (e) => {
  //   const baseUrl = process.env.REACT_APP_API + "update-userprofilepic";
  //   const selected = e.target.files[0];
  //   const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
  //   if (selected && ALLOWED_TYPES.includes(selected.type)) {
  //     let formData = new FormData();
  //     setLoading(true);
  //     formData.append("user_id", id.featureId);
  //     formData.append("file", selected);
  //     let axiosConfig = {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //         "x-access-token": token,
  //       },
  //     };
  //     const res = await axios
  //       .patch(baseUrl, formData, axiosConfig)
  //       .then((response) => {
  //         setFile({
  //           files: response?.data?.data?.document_name,
  //           preview: response?.data?.data?.document_name,
  //         });
  //         setLoading(false);
  //         setError(false);
  //       });
  //   } else {
  //     setError(true);
  //     setLoading(false);
  //   }
  // };

  const onSubmit = async (data) => {
    setLoading(true);
    let formData = new FormData();
    for (let dataKey in data) {
      if (dataKey === "preview") {
        for (let previewKey in data[dataKey]) {
          formData.append(`preview[${previewKey}]`, data[dataKey][previewKey]);
        }
      } else {
        formData.append(dataKey, data[dataKey]);
      }
    }
    formData.append("id", id.featureId);
    // if (file.files !== "" && team?.data?.profile_pic == "") {
    //   formData.append("file", file?.files);
    // } else if (file.files !== "" && team?.data?.profile_pic !== "") {
    //   formData.append("file", file?.files);
    //   formData.append("profile_pic_name", team?.data?.profile_pic);
    // }
    if (isFile) {
      formData.append("media", file?.files);
    }
    // formData.append("profile_pic_name", profile_pic_name);
    try {
      const res = await axios({
        method: "PATCH",
        url: process.env.REACT_APP_API + "admin/feature/update",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });

      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/features");
      }
    } catch (error) {
      if (error.response !== "" && error.response.data.message !== "") {
        setLoading(false);
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Edit New Feature</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <div className="imgChange-div">
                <img src={ImgChangeIcon} alt="" className="imgChangeIcon" />
              </div>
              <input
                type="file"
                name="file"
                accept="image/png , image/jpeg"
                title=""
                className="profile-pic-select"
                onChange={(e) => profileImage(e)}
              />

              <img
                src={file ? file.preview : feature?.data?.feature_image}
                alt=""
                className="setting-profile"
              />
            </div>

            {error && (
              <span style={{ color: "red" }}>
                Please upload file in jpg,jpeg and png format
              </span>
            )}
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>Feature Name</label>
                <input
                  type="text"
                  name="feature_name"
                  {...register("feature_name", {
                    required: "Feature name is required",
                    pattern: {
                      value: /^[a-zA-Z._ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Feature Name"
                />
                {errors.feature_name && (
                  <div className="invalid-feedback">
                    {errors.feature_name.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Feature Title</label>
                <input
                  type="text"
                  name="feature_title"
                  {...register("feature_title", {
                    required: "Title is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Feature Title"
                />
                {errors.feature_title && (
                  <div className="invalid-feedback">
                    {errors.feature_title.message}
                  </div>
                )}
              </div>

              <div className="formInput">
                <label>Description</label>

                <textarea
                  type="text"
                  name="feature_description"
                  {...register("feature_description", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  className="description-textarea"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.feature_description && (
                  <div className="invalid-feedback text-left">
                    {errors.feature_description.message}
                  </div>
                )}
              </div>

              <div className="formInput"></div>
              {/* <div className="formInput"></div> */}

              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editteam;
